import fetcher from '@/utils/fetcher';
import { UserProvider } from '@auth0/nextjs-auth0/client';
import { FC } from 'react';
import { ContentfulLivePreviewProvider } from '@contentful/live-preview/react';
import Cookies from 'js-cookie';
import { COOKIES } from '@/types';
import ClientSideOpcoContext from './client-side-opco';
import FeatureTogglesContext from './feature-toggles';
import MicrocopyContext from './microcopy';
import SharedComponentsProvider from './shared-components/shared-components-provider';
import { ShoppingProviderComponentProperties } from './index.types';

export const ShoppingProviders: FC<ShoppingProviderComponentProperties> = ({
  children,
  clientSideOpco,
  microcopy,
  featureToggles,
  loadingComponent,
  aviosCMSToken,
  sharedHeaderFooterEnvironment,
}) => {
  return (
    <ContentfulLivePreviewProvider
      locale={clientSideOpco.locale}
      enableInspectorMode={Cookies.get(COOKIES.DRAFT_MODE) === 'true'}
      enableLiveUpdates={false}
      debugMode={false}
      targetOrigin="https://app.contentful.com"
    >
      <ClientSideOpcoContext.Provider value={clientSideOpco}>
        <FeatureTogglesContext.Provider value={featureToggles}>
          <MicrocopyContext.Provider value={microcopy}>
            <UserProvider fetcher={fetcher}>
              <SharedComponentsProvider
                cms={{
                  aviosCMSToken,
                  sharedHeaderFooterEnvironment,
                }}
                opcoId={clientSideOpco.opcoId}
                loadingComponent={loadingComponent}
              >
                {children}
              </SharedComponentsProvider>
            </UserProvider>
          </MicrocopyContext.Provider>
        </FeatureTogglesContext.Provider>
      </ClientSideOpcoContext.Provider>
    </ContentfulLivePreviewProvider>
  );
};
